<script>
import ItemComponent from './Item/component.vue';

export default {
  components: {
    ItemComponent,
  },
  props: {
    module: {
      type: Object,
    },
  },
  methods: {
    add() {
      this.module.add();
    },
    remove(item) {
      this.module.remove(item);
    },
  },
};
</script>
<template>
  <Card>
    <CardTitle>
      Тарифы
      <div  slot="btn" class="tariff-btn-place">
        <div class="tariff-switch">
          <span>Не использовать тариф:</span>
        <el-switch
          v-model="module.tour.dontUseTariffs"
          active-color="#13ce66"
          inactive-color="#ff4949"
        >
        </el-switch>
          </div>
        <BtnPrimary
          @click="add"
          v-if="!module.tour.dontUseTariffs"
        >
          Добавить тариф
        </BtnPrimary>
      </div>
    </CardTitle>
    <ItemComponent
      v-for="(item, idx) in module.correctItems"
      :class="`${item.isDefault ? 'disabled-form' : ''}`"
      :key="idx"
      :module="item"
      @remove="remove(item)"
    />
    <CardNoLength v-if="!module.correctItems.length && !module.tour.dontUseTariffs">
      Добавьте тарифы
    </CardNoLength>
  </Card>
</template>
<style lang="scss">
.tariff {
  &-btn-place {
    display: flex;
    flex-direction: row;
  }
  &-switch {
    span{
      font-size: 14px;
      font-weight: 500;
      margin-right: 3px;
    }
    padding: 7px;
    margin-right: 10px;
  }
}
.disabled-form{
  visibility: hidden;
  height: 0px;
}
</style>
